<div class="registrant-wrapper">
    <sl-details [open]="!props['hidden']" (sl-show)="onOpenDrawer()" (sl-hide)="onCloseDrawer()">
        <div slot="summary" class="registrant-header">
            <span class="registrant__name">{{registeredUserName()}}<span class="registrant__type"> {{registeredUserType()}}</span></span>
            <div class="registrant__options">
                <button type="button" *ngIf="!props['reserved']" (click)="onRefreshClick($event)">Refresh</button>
                <span *ngIf="!props['reserved']"> | </span>
                <button *ngIf="showCancelButton()" type="button" (click)="onCancelClick($event)">Cancel</button>
                <button *ngIf="props['showDelete']" type="button" (click)="onDeleteClick($event)">Delete</button>
                <button *ngIf="props['showLink']" type="button" (click)="onLinkClick($event)">Link</button>
                <button *ngIf="props['showUnlink']" type="button" (click)="onUnlinkClick($event)">Unlink</button>
            </div>
        </div>
        <div class="registrant-body">
            <label *ngIf="props.label">
                {{ props.label | htmlDecode }}
                <span class="required-color" *ngIf="props.required">*</span>
            </label>
            <div (sl-show)="$event.stopPropagation()" (sl-hide)="$event.stopPropagation()">
                <ng-container #fieldComponent></ng-container>
            </div>
        </div>
    </sl-details>
</div>

<sl-dialog [open]="modalOpen" [noHeader]="true" (sl-hide)="onClose()">
    <span>Remove this {{wrapperType()}}?</span>
    <sl-divider></sl-divider>
    <span>Are you sure you want to remove this {{wrapperType()}}?</span>
    <sl-divider></sl-divider>
    <div class="button-wrapper">
        <sl-button class="btn--secondary" (click)="onClose()">Cancel</sl-button>
        <sl-button class="button__remove btn--primary" (click)="onRemove()">Remove</sl-button>
    </div>
</sl-dialog>
